import { render, staticRenderFns } from "./CourierSupplement.vue?vue&type=template&id=5b9a4c6f&scoped=true&"
import script from "./CourierSupplement.vue?vue&type=script&lang=js&"
export * from "./CourierSupplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a4c6f",
  null
  
)

export default component.exports